define('model/GdprReportModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Reviews data model
     *
     * @class ReviewsModel
     */
    return BaseModel.extend({

        urlRoot: '/gdpr-report/info',

        defaults: {
            id: null,
            client_info : null,
            contact_widget : null,
            openid_data : null,
            client_devices : null,
            bookings : null,
            emails : null,
            reviews : null,
            memberships : null,
            code_confirmed: true // by default do not ask for confirmation until model loaded 
        },

        initialize: function () {

            BaseModel.prototype.initialize.call(this);
        }

    });

});

